import './index.less'
import '../../wea-browser-hrm-mult/style/index.css'


// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-thumbnail/style/index.js